import { Component } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-manage-file-upload',
  templateUrl: './manage-file-upload.component.html',
  styleUrls: ['./manage-file-upload.component.css'],
   styles: [
        `:host ::ng-deep .p-rowgroup-footer td {
            font-weight: 700;
        }
        
        :host ::ng-deep .p-rowgroup-header {
           
        
            .p-row-toggler {
                vertical-align: middle;
                margin-right: .25rem;
            }
        }`
    ],
})
export class ManageFileUploadComponent {
 constructor(private UserService:UserService){
this.getUserError()
 }
  users:any = [];

  onUpload(event: any) {
    // Custom upload handler
    console.log('Uploaded file:', event);
  }

  onDownload(user: any) {
    // Simulate rocket-like file download with animation
    alert(`File for ${user.name} is being downloaded!`);
    
    // Logic to download the file
  }
  getUserError(){
    this.UserService
    .getUserError()
    .subscribe({
      next : (res:any) => {
        if(res.result) {

        const data = res.result
        this.users=data
        console.log(data)         
         } else {

         } 
      },error : (err) => {

        console.error("Error in fetching all getRoleList");
      }
    }
  )
  }

  generatePDF(name:any,filename:any){
    console.log('34')
    this.UserService
    .getpdf(name)
    .subscribe({
      next : (res:any) => {
        console.log(res)
        if(res) {
         let data:any
         data=res
        //  console.log(data)
  
  console.log(data)
        var fileName = filename;
  var blob = data.body;
  const file = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  
  var a = document.createElement("a");
  a.href = window.URL.createObjectURL(file);
  a.download = fileName;
  
  // Append the link to the document
  document.body.appendChild(a);
  
  // Trigger a click on the link to start the download
  a.click();
  
  // Remove the link from the document after the download is initiated
  document.body.removeChild(a);
  
  // Revoke the object URL to avoid memory leaks
  window.URL.revokeObjectURL(a.href);
        } else {    

        } 
      },error : (err) => {
        console.log(err)
  
  
      }
    }
  )
  
  }

  downloadExcelFromBlob(blobData: Blob, fileName: string): void {
    // Step 1: Create a download link
    const link = document.createElement('a');
  
    // Step 2: Create an object URL for the Blob
    const url = window.URL.createObjectURL(blobData);
  
    // Step 3: Set the link's href to the object URL and define the download file name
    link.href = url;
    link.download = `${fileName}.xlsx`;
  
    // Step 4: Append the link to the document and trigger the download
    document.body.appendChild(link);
    link.click();
  
    // Step 5: Clean up - Remove the link from the DOM and revoke the object URL
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
  formatTimestamp(timestamp: any): any {
      let convertedValue:any = ""
      if(timestamp){
      let datepipe = new DatePipe("en");
      //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
      convertedValue =  datepipe.transform(timestamp, "dd-MM-yyyy HH:mm:ssa");
      // convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
  
      }
      return convertedValue;
    
  }
}
